import useAppSelector from '~hooks/useAppSelector';
import { selectAddonsNewsfeedConfig } from '~store/selectors';
import { Item } from './Item';
import { LayoutVariant } from './LayoutVariant';
import { LinkProps } from './Link';

const NoLink = ({ children, className }: LinkProps) => {
  return <div className={className}>{children}</div>;
};

export function Teaser() {
  const { teaserShow, teaserTitle, teaserText, teaserImage } = useAppSelector(selectAddonsNewsfeedConfig);
  if (!teaserShow) return null;

  return (
    <>
      <Item
        variant={LayoutVariant.FULL}
        title={teaserTitle}
        description={teaserText}
        imageSrc={teaserImage}
        LinkComponent={NoLink}
      />
    </>
  );
}
